export const textToColor = (text: string) => {
  let hash = 0;
  for (let i = 0; i < text.length; i++) {
    hash = text.charCodeAt(i) + ((hash << 5) - hash);
  }

  let r = (hash >> 0) & 0xff;
  let g = (hash >> 8) & 0xff;
  let b = (hash >> 16) & 0xff;

  // Lighten by blending with white (increase by 70%)
  r = Math.floor(r + (255 - r) * 0.7);
  g = Math.floor(g + (255 - g) * 0.7);
  b = Math.floor(b + (255 - b) * 0.7);

  return `#${r.toString(16).padStart(2, '0')}${g
    .toString(16)
    .padStart(2, '0')}${b.toString(16).padStart(2, '0')}`;
};
